export const shallowEqual = (objA, objB, comparator) => {
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    return (keysA.length == keysB.length &&
        keysA.every((key) => comparator
            ? comparator(objA[key], objB[key])
            : objA[key] === objB[key]));
};
//# sourceMappingURL=shallowEqual.js.map